import React, { forwardRef } from 'react';
import { WidgetConfig } from '.';
import { MdDragIndicator } from 'react-icons/md';
import './styles.scss';
import { ActionIcon, Badge, Stack } from '@mantine/core';
import { Flex, Text } from '@mantine/core';
import { DraggableProvided, DraggableStateSnapshot } from 'react-beautiful-dnd';
import { HiOutlineEye, HiOutlineEyeOff } from 'react-icons/hi';
import { HiTrash } from 'react-icons/hi2';

interface DraggableItemProps {
  item: WidgetConfig;
  provided: DraggableProvided;
  snapshot: DraggableStateSnapshot;
  onHide: (item: WidgetConfig) => void;
}

const DraggableItem = forwardRef<any, DraggableItemProps>((props, ref) => {
  const { item, provided, onHide } = props;
  const handleClick = () => {
    onHide(item);
  };
  return (
    <div
      ref={ref}
      {...provided.draggableProps}
      {...provided.dragHandleProps}
      className="draggable-container__item"
    >
      <Flex gap={8} align={'center'} flex={1}>
        <MdDragIndicator size={24} />
        <Stack flex={1} gap={0}>
          {!item.display && <Badge color="red">Hidden</Badge>}
          <Text fz={14} fw={500}>
            {item.title}
          </Text>
        </Stack>

        <ActionIcon
          variant="light"
          aria-label="Settings"
          c={'cyan'}
          //   bg={''}
          //   c={'indigo'}
          onClick={handleClick}
        >
          {item.display ? (
            <HiOutlineEye size={16} />
          ) : (
            <HiOutlineEyeOff size={16} />
          )}
        </ActionIcon>
        {item?.onDelete && (
          <ActionIcon
            variant="light"
            aria-label="Settings"
            color={'red'}
            onClick={() => item?.onDelete(item)}
          >
            <HiTrash size={16} />
          </ActionIcon>
        )}
      </Flex>
    </div>
  );
});

export default DraggableItem;
